/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import csvDownload from 'json-to-csv-export'

import { makeStyles, 
    Theme, 
    TextField, 
    MenuItem, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogContentText, 
    DialogTitle,
    Checkbox,
    Switch,
    FormControlLabel,
    InputAdornment,
    Grid,
    IconButton } from '@material-ui/core';

import { AppContext } from '../stores/AppStore';
import { UserContext } from '../stores/UserStore';
import { SecurityContext } from '../stores/SecurityStore';
import LoadingOverlay from '../components/common/LoadingOverlay';

import PageContainer from '../components/layout/PageContainer';
import PageToolbar from '../components/layout/PageToolbar';
import PageBody from '../components/layout/PageBody';

import DataTable from '../components/table/DataTable';
import Button from '../components/common/Button';

import AddIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import RefreshIcon from '@material-ui/icons/Refresh';

import { purple } from '@material-ui/core/colors';

import flags from '../assets/jsons/flags.json'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        // padding: theme.spacing(2),
    },
    dialogRoot: {
        '& .MuiPaper-root': {
            backgroundColor: theme.palette.text.primary,
        }
    },
    dialogTitle: {
        padding: '10px 24px 0px 24px',
        color: '#00000094'
    },
    dialogContent: {
        minHeight: '50vh',
        color: '#00000094',
        // padding: '20px',
        // display: 'flex',
        // alignItems: 'flex-start',
        // justifyContent: 'flex-start',
        // flexDirection: 'column'
        '& .MuiPaper-elevation1': {
            boxShadow: 'none',
            // '& .MuiToolbar-root': {
            //     backgroundColor: 'blue'
            // }, 
        }
    },
    textField: {
        width:  'calc(100% - 20px)',
        margin: theme.spacing(3,0,0,0),
        fontSize: 12,
        '& .MuiFormLabel-root': {
            color: '#666666'
        },
        '& .MuiInput-root': {
            // color: theme.palette.primary.main,
            color: '#000000',
            '& .MuiInputBase-input': {
                paddingLeft: '10px',
                backgroundColor: '#FFFFFF',
                height: '1.8em',
                borderRadius: '4px',
                boxShadow: 'inset 0 1px 3px 0 rgba(0,0,0,0.14)'
            },
            '& .MuiSelect-select.MuiSelect-select': {
                paddingTop: '10px',
                paddingBottom: '0px'
            },
            '& .Mui-disabled': {
                opacity: 0.5
            }                
        }
    },
    list: {
        width: 'calc(100% - 20px)',
        backgroundColor: theme.palette.text.primary,
    },         
    listItem: {
        margin: '0px',
        padding: '0px'
    },
    checkbox: {
        margin: '0px',
        padding: '0px'
    },
    listItemText: {
        margin: '0px',
        padding: '0px'
    },
    row: {
        display: 'flex', 
        flexDirection: 'row'
    },
    detailGrid: {
        margin: '0 20px',
        fontSize: 13
    },
    dialogActions: {
        '& .MuiButton-contained.Mui-disabled': {
            color: theme.palette.grey[300],
            border: '1px solid' 
        }
    },
    buttonPurple: {
        color: theme.palette.getContrastText(purple[500]),
        backgroundColor: purple[500],
        '&:hover': {
            backgroundColor: purple[700],
        },
    },
    switchField: {
        display: 'flex', 
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width:  '100%',
        color: theme.palette.text.secondary
    },
    treeItem: {
        '& .MuiFormControlLabel-root': {
            marginLeft: '-5px'
        },
        '& .MuiButtonBase-root': {
            padding: '5px 5px'
        },        
        '& .MuiTypography-root.MuiTreeItem-label.MuiTypography-body1': {
            backgroundColor: '#ffffff !important',
        },
        '& .MuiTreeItem-root.Mui-selected': {
            '& .MuiTreeItem-label': {
                backgroundColor: '#ffffff !important',
            },
        },
        '& .MuiFormControlLabel-root.Mui-disabled': {
            '& span': {
                color: theme.palette.grey[300]
            }
        }
    },
}));

const Users = () => {
    const history = useHistory();    
    const classes = useStyles();
    const { applicationSearchText, setApplicationSearchText, showSuccessMessage, showErrorMessage } = useContext(AppContext);
    const { currentUser } = useContext(UserContext);

    const { usersData, usersManagement } = useContext(SecurityContext)
    const [isLoading, setLoading] = useState(true);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [action, setAction] = useState(null);
    const [selectedProfiles, setSelectedProfiles] = useState<string[]>([]);
    const [treeData, setTreeData] = useState<RenderTree[]>([]);
    const [selectApp, setSelectApp] = useState(null);
    const [toogleLabel, setToogleLabel] = useState(true);

    const userTypes = [
        {value: 'employee', text: 'Vallourec Employee'},
        {value: 'customer', text: 'Customer'},
        {value: 'third', text: 'Third'},
        {value: 'other', text: 'Other'},
    ];

    useEffect(() =>  {
        if (applicationSearchText) {
            setApplicationSearchText('');
            history.push('/search/users/'+applicationSearchText);
        }
    }, [applicationSearchText]);


    useEffect(() =>  {
        init();
    }, []);

    const init = () => {
        setLoading(true);        
        usersManagement({init: true}).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setLoading(false);            
        });    
    }
    
    const handleClickForeignUser = () => {
        // const record = usersData.tableData.find(x => x.id === rowData.id);
        // setCurrentRecord(record);
        setAction('ForeignUser');
    };
        
    const handleClickNew = () => {
        const record = {measuringUnit: '', profiles: [], groups: []};
        setAction('New');
        setCurrentRecord(record);
    };

    const handleClickEdit = (event, rowData) => {
        const record = usersData.tableData.find(x => x.id === rowData.id);
        setCurrentRecord(record);
        setAction('Edit');
    };    

    const handleAppChange = (event: React.ChangeEvent<HTMLInputElement>) => {       
        setSelectApp(event.target.value);
    }; 

    useEffect(() =>  {
        if (currentRecord && (action === 'Permission' || action === 'Permission+New')) {
            setSelectApp(usersData.applicationData[0].id);
            setSelectedProfiles(currentRecord.profiles.map(x => x.id));
        }
    }, [currentRecord, action]);

    useEffect(() =>  {
        if (currentRecord && usersData.profilesData && usersData.checkData && selectApp) {
            const list = JSON.parse(JSON.stringify(usersData.profilesData)).map(x => {
                const profile = {
                  ...x,
                  disabled: true
                }
                const profileCkeck = usersData.checkData.find(x => x.id === profile.id);
                if (profileCkeck && profileCkeck.isOwner) {
                  profile.disabled = false;
                }
                return profile;
            });

            const treeRoot: RenderTree[] = [];
            const profile = list.find(profile => profile.applicationId === selectApp && profile.id === profile.ownerId);
            if (profile) {
                const root = { id: profile.id, name: toogleLabel ? profile.label : profile.name, disabled: profile.disabled, children: [] }
                loadTreeChild(root, list, selectApp);    
                treeRoot.push(root);                        
            }
            setTreeData(treeRoot);
        }
    }, [usersData.profilesData, usersData.checkData, selectApp, toogleLabel]);


    const loadTreeChild = (node: RenderTree, list, appId) => {
        const profiles = list.filter(x => x.applicationId === appId && x.id !== node.id && x.ownerId === node.id).sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase()) ? 1 : -1);
        for (const profile of profiles) {
            const child = { id: profile.id, name: toogleLabel ? profile.label : profile.name, disabled: profile.disabled, children: [] };
            loadTreeChild(child, list, appId);
            node.children.push(child);
        }
    }

    const handleClickDelete = (event, rowData) => {
        setAction('Delete');
        setCurrentRecord(rowData);
    };    

    const handleClickClose = () => {
        setAction(null);
        setCurrentRecord(null);
        setTreeData([]);
        setSelectedProfiles([]);
        setSelectApp(null);
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const record = {...currentRecord};
        record[event.target.name] = event.target.value;
        setCurrentRecord(record);
    };        

    const handleToggleChange = (event, rowData) => {
        const record = {...rowData};
        setLoading(true);
        const inactive = record.inactive === undefined ? true : !record.inactive;            
        const text = inactive ? 'inactivated' : 'activated' 
        usersManagement({ status: {id: record.id,  email: record.email, inactive: inactive }}).then(() => {
            showSuccessMessage('User '+text+' success!');
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setAction(null);
            setCurrentRecord(null);
            setLoading(false);            
        });
    };        

    const doClickReset = () => {
        setLoading(true);            
        usersManagement({ reset: currentRecord }).then(() => {
            showSuccessMessage('User password reset success!');
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setAction(null);
            setCurrentRecord(null);
            setLoading(false);            
        });
    };      


    const doClickDelete = () => {
        setLoading(true);            
        usersManagement({ delete: currentRecord.id }).then(() => {
            showSuccessMessage('User delete success!');
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setAction(null);
            setCurrentRecord(null);
            setLoading(false);            
        });
    };      

    const doClickSave = () => {
        if (action === 'New') {
            setAction('Permission+New');
        } else {
            setLoading(true);        
            currentRecord.measuringUnit = currentRecord.measuringUnit ? currentRecord.measuringUnit : '';
            usersManagement({ save: currentRecord }).then(() => {
                showSuccessMessage('User saved success!');
            }).catch(errorMessage => {
                showErrorMessage(errorMessage);
            }).finally(() => {
                setAction(null);
                setCurrentRecord(null);
                setLoading(false);            
            });    
        }
    };      

    const doClickSavePermission = () => {
        setLoading(true);        

        currentRecord.profiles =  selectedProfiles;
        if (currentRecord.foreignProfiles) {
            currentRecord.profiles = currentRecord.profiles.concat(currentRecord.foreignProfiles);
            delete currentRecord.foreignProfiles;
        }

        const params = action === 'Permission+New' ?  { save: currentRecord } : { permission: {id: currentRecord.id, profiles: currentRecord.profiles, groups: currentRecord.groups} };

        usersManagement(params).then(() => {
            showSuccessMessage('User saved success!');
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setAction(null);
            setCurrentRecord(null);
            setTreeData([]);
            setSelectedProfiles([])
            setSelectApp(null);
            setLoading(false);            
        });           

    };      

    const handleClickPermissions = (event, rowData) => {
        setAction('Permission');
        const record = usersData.tableData.find(x => x.id === rowData.id);
        record.profiles =  record.profiles ? record.profiles : [];
        setCurrentRecord(record);
    };        
    
    const handleSelectForeignUser = (event, rowData) => {
        setAction('Permission');
        const record = usersData.foreignData.find(x => x.id === rowData.id);
        record.foreignProfiles =  record.profiles ? record.profiles : [];
        record.profiles = [];
        setCurrentRecord(record);
    };        

    const renderTableData = useMemo(() => <DataTable
        isLoading={action === null && isLoading}
        columns={[
            { title: 'First Name', field: 'firstName' },
            { title: 'Last Name', field: 'lastName' },
            { title: 'Email', field: 'email' },
            { title: 'User Type', field: 'type', render: rowData => <span>{rowData.type && userTypes.find(x => x.value === rowData.type).text}</span> },
            { title: 'Phone Number', field: 'phoneNumber', render: rowData => <span>{(rowData.countryCode ? rowData.countryCode + ' ' : '') + rowData.phoneNumber ? rowData.phoneNumber : '' }</span> }

        ]}
        data={JSON.parse(JSON.stringify(usersData.tableData))}
        exportCsv={(columns, data) => {
            const csvData = [];
            for (const d of data) {
                const obj = {};
                for (const c of columns) {
                    obj[c.title] = d[c.field];
                }
                obj['Profiles'] = d.profileName;
                csvData.push(obj);
            }
            csvDownload(csvData, 'users_'+Date.now()+'.csv', ';');
        }}        
        actions={[
            {
                icon: () => <EditIcon color="primary" />,
                tooltip: 'Edit User',
                onClick: handleClickEdit,
                hidden: !currentUser.roles.USER.SAVE_RECORD
            },
            {
                icon: () => <DeleteIcon color="error" />,
                tooltip: 'Delete User',
                onClick: handleClickDelete,
                hidden: !currentUser.roles.USER.REMOVE_RECORD
            },
            {
                icon: () => <PlaylistAddCheckIcon color="secondary" />,
                tooltip: 'Permissions',
                onClick: handleClickPermissions,
                hidden: !currentUser.roles.USER.SAVE_RECORD
            },
            {
                icon: () => <RefreshIcon color="primary" />,
                tooltip: 'Refresh',
                onClick: (event) => init(),
                isFreeAction: true
            },
            rowData => (
                {
                    icon: () => rowData.inactive ? <ToggleOffIcon color="action" /> : <ToggleOnIcon color="primary" />,
                    tooltip: rowData.inactive ? 'User Inactive' : 'User Active',
                    onClick: handleToggleChange,
                    hidden: !currentUser.roles.USER.SAVE_RECORD
                }
            )
        ]}               
        detailPanel={rowData => {
            return (
                <Grid container className={classes.detailGrid} spacing={1}>
                    <Grid item xs={4}>
                        <b>Company:</b> {rowData.company}
                    </Grid>
                    <Grid item xs={4}>
                        <b>Country:</b> {rowData.location}
                    </Grid>
                    <Grid item xs={4}>
                        <b>Job:</b> {rowData.position}
                    </Grid>
                    <Grid item xs={12}>
                        <b>Address:</b> {rowData.address}
                    </Grid>
                    <Grid item xs={4}>
                        <b>ZipCode:</b> {rowData.zipCode}
                    </Grid>
                    <Grid item xs={4}>
                        <b>City:</b> {rowData.city}
                    </Grid>
                    <Grid item xs={4}>
                        <b>Country:</b> {rowData.country}
                    </Grid>
                    <Grid item xs={12}>
                        <b>Profiles:</b> {rowData.profileName}
                    </Grid>
                </Grid>
            )
        }}/>, [usersData, isLoading]);
            
    const getOnChange = (checked: boolean, nodes: RenderTree) => {
        const allNode: string[] = [nodes.id];
        let array = checked
        ? [...selectedProfiles, ...allNode]
        : selectedProfiles.filter(value => !allNode.includes(value));
    
        array = array.filter((v, i) => array.indexOf(v) === i);
    
        setSelectedProfiles(array);
    }


    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        setToogleLabel(event.target.checked);
    };         
    
    const renderTree = (nodes: RenderTree) => (
        <TreeItem
        key={nodes.id}
        nodeId={nodes.id}
        className={classes.treeItem}
        label={<FormControlLabel
            control={
                <Checkbox
                disabled={nodes.disabled}
                checked={selectedProfiles.some(item => item === nodes.id)}
                onChange={event =>
                    getOnChange(event.currentTarget.checked, nodes)
                }
                onClick={e => e.stopPropagation()}
                />
            }
            label={<>{nodes.name}</>}
            key={nodes.id}
            />}
        >
        {Array.isArray(nodes.children)
            ? nodes.children.map(node => renderTree(node))
            : null}
        </TreeItem>
    );

    const renderListProfiles = useMemo(() => <TreeView
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpanded={usersData.profilesData ? usersData.profilesData.map(x => x.id) : []}
            defaultExpandIcon={<ChevronRightIcon />}>
                { 
                    treeData.map((item) => {
                        return renderTree(item);
                    })
                }
    </TreeView>, [usersData.profilesData, treeData, selectedProfiles]);


    return (
        <PageContainer className={classes.root}>
            <PageToolbar title="Users Management" backButton={true}>
                { currentUser.roles.USER.SAVE_RECORD && <>
                    <Button variant="contained" color="secondary" size="small" startIcon={<DeviceHubIcon />} onClick={handleClickForeignUser} >
                        Foreign User
                    </Button>
                    <Button variant="contained" color="primary" size="small" startIcon={<AddIcon />} onClick={handleClickNew} >
                        New User
                    </Button>
                </>}
            </PageToolbar>
            <PageBody>
            { usersData.tableData && renderTableData }
            </PageBody>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="md"
                open={action === 'New' || action === 'Edit'}
                aria-labelledby="save-dialog">
                <DialogTitle className={classes.dialogTitle} id="save-dialog">{action} User</DialogTitle>
                <DialogContent dividers={false} className={classes.dialogContent}>
                    { currentRecord && <>
                        <div className={classes.row}>
                            <TextField
                                label="First Name:"
                                required
                                placeholder="First Name"
                                id="firstName"
                                name="firstName"
                                className={classes.textField}
                                error={currentRecord.firstName !== undefined && !currentRecord.firstName}
                                value={currentRecord.firstName}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />
                            <TextField
                                label="Last Name:"
                                required
                                placeholder="Last Name"
                                id="lastName"
                                name="lastName"
                                className={classes.textField}
                                error={currentRecord.lastName !== undefined && !currentRecord.lastName}
                                value={currentRecord.lastName}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />
                        </div>
                        <div className={classes.row}>
                            <TextField
                                label="Email:"
                                required
                                type="email"
                                placeholder="Email"
                                id="email"
                                name="email"
                                className={classes.textField}
                                error={currentRecord.email !== undefined && !currentRecord.email}
                                value={currentRecord.email}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />
                        </div>

                        <div className={classes.row}>
                            <TextField
                                label="Company:"
                                required
                                placeholder="Company"
                                id="company"
                                name="company"
                                className={classes.textField}
                                error={currentRecord.company !== undefined && !currentRecord.company}
                                value={currentRecord.company}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />
                            <TextField
                                label="Country:"
                                required
                                placeholder="Country"
                                id="location"
                                name="location"
                                className={classes.textField}
                                error={currentRecord.location !== undefined && !currentRecord.location}
                                value={currentRecord.location}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />
                            <TextField
                                label="Job:"
                                required
                                placeholder="Job"
                                id="position"
                                name="position"
                                className={classes.textField}
                                error={currentRecord.position !== undefined && !currentRecord.position}
                                value={currentRecord.position}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />                                
                        </div>

                        <div className={classes.row}>
                            <TextField
                                label="Address:"
                                required
                                placeholder="Address"
                                id="address"
                                name="address"
                                className={classes.textField}
                                error={currentRecord.address !== undefined && !currentRecord.address}
                                value={currentRecord.address}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />
                        </div>

                        <div className={classes.row}>
                            <TextField
                                label="ZipCode:"
                                required
                                placeholder="ZipCode"
                                id="zipCode"
                                name="zipCode"
                                className={classes.textField}
                                error={currentRecord.zipCode !== undefined && !currentRecord.zipCode}
                                value={currentRecord.zipCode}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />
                            <TextField
                                label="City:"
                                required
                                placeholder="City"
                                id="city"
                                name="city"
                                className={classes.textField}
                                error={currentRecord.city !== undefined && !currentRecord.city}
                                value={currentRecord.city}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />
                            <TextField
                                label="Country:"
                                required
                                placeholder="Country"
                                id="country"
                                name="country"
                                className={classes.textField}
                                error={currentRecord.country !== undefined && !currentRecord.country}
                                value={currentRecord.country}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />
                        </div>

                        <div className={classes.row}>
                            <TextField
                                select
                                label="Country Code:"
                                required
                                placeholder="Country Code"
                                id="countryCode"
                                name="countryCode"
                                className={classes.textField}
                                error={currentRecord.countryCode !== undefined && !currentRecord.countryCode}
                                value={currentRecord.countryCode}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                          { currentRecord.countryCode && flags.find(x => x.code === currentRecord.countryCode) && <img src={flags.find(x => x.code === currentRecord.countryCode).src} alt="Flag Selected" width="36" height="36" /> }
                                        </InputAdornment>
                                      )                                    
                                }}>
                                    { 
                                        flags.map((flag) => (
                                            <MenuItem key={flag.code} value={flag.code}>
                                                {flag.country}                                                
                                            </MenuItem>
                                        ))
                                    }
                            </TextField>
                            <TextField
                                label="Phone:"
                                required
                                placeholder="Phone"
                                id="phoneNumber"
                                name="phoneNumber"
                                className={classes.textField}
                                error={currentRecord.phoneNumber !== undefined && !currentRecord.phoneNumber}
                                value={currentRecord.phoneNumber}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />
                        </div>

                        <div className={classes.row}>
                            <TextField
                                select
                                label="User Type:"
                                required
                                placeholder="User Type"
                                id="type"
                                name="type"
                                className={classes.textField}
                                error={currentRecord.type !== undefined && !currentRecord.type}
                                value={currentRecord.type}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}>
                                    {   
                                        userTypes.map((type) => (
                                            <MenuItem key={type.value} value={type.value}>
                                                {type.text}                                                
                                            </MenuItem>
                                        ))                                    
                                    }
                            </TextField>
                            <TextField
                                select
                                label="Default Language:"
                                required
                                placeholder="Default Language"
                                id="language"
                                name="language"
                                className={classes.textField}
                                error={currentRecord.language !== undefined && !currentRecord.language}
                                value={currentRecord.language}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}>
                                    <MenuItem value="pt-BR">Portuguese</MenuItem>                                    
                                    <MenuItem value="en">English</MenuItem>                                    
                                    <MenuItem value="es">Spanish</MenuItem>                                    
                            </TextField>
                        </div>

                    </> }
                </DialogContent>
                <DialogActions className={classes.dialogActions} >
                    {
                        action === 'Edit' && <Button  variant="contained" className={classes.buttonPurple} startIcon={<DoneAllIcon />} onClick={doClickReset} >
                            Reset Temporary Password
                        </Button>
                    }
                    <div style={{flex: '1 0'}}></div>
                    <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickClose}>
                        Close
                    </Button>
                    <Button disabled={currentRecord && (!currentRecord.firstName || !currentRecord.lastName || !currentRecord.email || !currentRecord.phoneNumber)} variant="contained" color="primary" startIcon={<SaveIcon />} onClick={doClickSave} >
                        Save
                    </Button>
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="sm"
                open={action === 'Delete'}
                aria-labelledby="delete-dialog">
                <DialogTitle className={classes.dialogTitle} id="delete-dialog" >{action} User</DialogTitle>
                <DialogContent dividers={false}>
                    <DialogContentText>
                        Do you want delete user "{currentRecord && currentRecord.firstName + ' ' + currentRecord.lastName}"? 
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickClose}>
                        Close
                    </Button>
                    <Button variant="contained" color="primary" startIcon={<DeleteIcon />} onClick={doClickDelete} >
                        Delete
                    </Button>
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="md"
                open={action === 'Permission' || action === 'Permission+New'}
                aria-labelledby="permissions-dialog">
                <DialogTitle className={classes.dialogTitle} id="permissions-dialog">Edit Permissions: {currentRecord && currentRecord.firstName + ' ' + currentRecord.lastName}</DialogTitle>
                <DialogContent dividers={false} className={classes.dialogContent} style={{maxHeight: 550, minHeight: 550}}>
                    { selectApp && usersData && usersData.applicationData && 
                        <div className={classes.row}>

                            <TextField
                                select
                                label="Select an Application:"
                                required
                                placeholder="Applications"
                                id="application"
                                name="application"
                                className={classes.textField}
                                style={{marginTop: '0px'}}
                                value={selectApp}
                                onChange={handleAppChange}                            
                                fullWidth
                                //margin="dense"
                                //variant="outlined"
                                InputLabelProps={{shrink: true}}>
                                    {   
                                        usersData.applicationData.map((app) => (
                                            <MenuItem key={app.id} value={app.id}>
                                                {toogleLabel ? app.label : app.name}                                                
                                            </MenuItem>
                                        ))                                    
                                    }
                            </TextField>
                        </div> 
                    }
                    { currentRecord && renderListProfiles }
                </DialogContent>
                <DialogActions className={classes.dialogActions} >
                    <div className={classes.switchField}>
                        <Switch 
                            name="toogleLabel" 
                            checked={toogleLabel}
                            onChange={handleSwitchChange}  
                            color="primary" />
                        <b>View Short Name</b>
                    </div>
                    
                    <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickClose}>
                        Close
                    </Button>
                    <Button variant="contained" color="primary" startIcon={<SaveIcon />} onClick={doClickSavePermission} >
                        Save
                    </Button>
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="md"
                open={action === 'ForeignUser'}
                aria-labelledby="foreign-user-dialog">
                <DialogTitle className={classes.dialogTitle} id="foreign-user-dialog">
                    <IconButton color="primary" component="span" onClick={handleClickClose}>
                        <ArrowBackIcon />
                    </IconButton> 
                    Select User
                </DialogTitle>
                <DialogContent dividers={false} className={classes.dialogContent}>
                    { usersData.foreignData && <DataTable
                        pageSize={10}
                        minBodyHeight="43vh"
                        columns={[
                            { title: 'First Name', field: 'firstName' },
                            { title: 'Last Name', field: 'lastName' },
                            { title: 'Email', field: 'email' },
                            // { title: 'User Type', field: 'type', render: rowData => <span>{rowData.type && userTypes.find(x => x.value === rowData.type).text}</span> }
                        ]}
                        data={JSON.parse(JSON.stringify(usersData.foreignData))}        
                        actions={[
                            {
                                icon: () => <DoneAllIcon color="secondary" />,
                                tooltip: 'Select User',
                                onClick: handleSelectForeignUser,
                                hidden: !currentUser.roles.USER.SAVE_RECORD
                            }
                        ]}               
                    /> }                
                </DialogContent>
                <LoadingOverlay open={isLoading} />
            </Dialog>
        </PageContainer>
    );
};

export interface RenderTree {
    id: string;
    name: string;
    disabled: boolean;
    children?: RenderTree[];
}
 

export default Users;
